var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c("div", { staticClass: "form-item" }, [
        _c("div", {
          staticClass: "embedCode hasi18n",
          domProps: { innerHTML: _vm._s(_vm.item.data.embedHtml) },
        }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }